import { FieldTypes, IField } from "./../store/fields/types";
import { LogicStates } from "./../app/SideBar/Logic/LogicPopup/LogicTypes";

export const getLogicByFieldType = (fields: IField[], id: string | undefined) => {
    if (fields) {
        const currentField = fields.find(field => {
            return field._id === id;
        });

        if (
            currentField &&
            currentField.type !== FieldTypes.HEADEING &&
            currentField.type !== FieldTypes.DESCRIPTION &&
            currentField.type !== FieldTypes.MAP &&
            currentField.type !== FieldTypes.PROMOCODE &&
            currentField.type !== FieldTypes.PAYMENT_METHOD &&
            currentField.type !== FieldTypes.CUSTOM_HTML
        )
            return LogicStates[currentField.type];
    }

    return { "": "" };
};
